// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"footer_infoButton__1GjVE","submitButton":"footer_submitButton__27-rB"};